import { DatabaseOutlined, DownloadOutlined } from '@ant-design/icons';
import { Button, Empty, List, Space, Tag, Typography, theme } from 'antd';
import { CardHeader } from 'components/headings';
import { traducirAparicion } from './misDatosDiccionario';
import React from 'react';

const { Text } = Typography;
const { useToken } = theme;

/**
 * Derecho de acceso: qué sabemos de la persona y en qué calidad.
 *
 * El `resumen` llega ordenado de mayor a menor por el backend; no lo reordenamos.
 * Cada fila pasa por el diccionario — acá nunca se pinta un nombre de tabla.
 */
const AparicionesPanel = ({
  resumen,
  totalRegistros,
  firmas,
  onDescargar,
  descargando,
  panelStyle,
}) => {
  const { token } = useToken();

  return (
    <div style={panelStyle}>
      <CardHeader
        icon={DatabaseOutlined}
        tint={token.colorInfo}
        title="Dónde apareces"
        subtitle="Los registros de la plataforma en los que estás mencionado"
        action={
          <Button
            icon={<DownloadOutlined />}
            onClick={onDescargar}
            loading={descargando}
            size="small"
          >
            Descargar todos mis datos
          </Button>
        }
      />
      <div style={{ padding: token.paddingMD }}>
        <Text type="secondary" style={{ display: 'block', marginBottom: token.marginMD }}>
          Puedes descargar una copia de todo lo que guardamos de ti en un archivo, para conservarlo
          o llevártelo a otra parte.
        </Text>

        <Space
          size={[token.marginXS, token.marginXS]}
          wrap
          style={{ marginBottom: token.marginMD }}
        >
          <Tag color="blue" style={{ margin: 0, fontWeight: 600 }}>
            {totalRegistros} {totalRegistros === 1 ? 'registro en total' : 'registros en total'}
          </Tag>
          <Tag color="default" style={{ margin: 0, fontWeight: 600 }}>
            {firmas === 1 ? 'Tienes 1 firma registrada' : `Tienes ${firmas} firmas registradas`}
          </Tag>
        </Space>

        {resumen.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <span>
                Todavía no apareces en ningún registro de trabajos. Solo tenemos los datos de tu
                cuenta.
              </span>
            }
          />
        ) : (
          <List
            size="small"
            dataSource={resumen}
            rowKey={(item) => `${item.tabla}|${item.rol}`}
            renderItem={(item) => {
              const { titulo, detalle, rol } = traducirAparicion(item.tabla, item.rol);

              return (
                <List.Item
                  extra={
                    <Tag color="default" style={{ margin: 0, fontWeight: 600 }}>
                      {item.cantidad}
                    </Tag>
                  }
                >
                  <List.Item.Meta
                    title={
                      <Space size={token.marginXS} wrap>
                        <span>{titulo}</span>
                        {rol && (
                          <Text type="secondary" style={{ fontSize: 12, fontWeight: 400 }}>
                            {rol}
                          </Text>
                        )}
                      </Space>
                    }
                    description={
                      detalle ? (
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          {detalle}
                        </Text>
                      ) : null
                    }
                  />
                </List.Item>
              );
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AparicionesPanel;
